import React, { Fragment, useContext } from "react";
import "../../styles/main.css";
import { HTMLContent, H1Content } from "../HTMLContent";
import { Carousel } from "react-bootstrap";
import Countdown from "../Main/Timer";
import Navbar from "./Navbar";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

function Header({
  obj,
  head,
  events,
  desc,
  status,
  bgbanner,
  scrollTo,
  handleParticipate,
  webinarCheck,
  challengeCheck,
}) {
  if (!obj) {
    return null;
  }

  const { language } = useContext(LanguageContext);
  return (
    <React.Fragment>
      <Navbar />
      <div className="hero-section">
        <div className="headsec1 headsec2 et_pb_section_parallax head_background et_section_regular sec_divider bottom_divider">
          <div className="bg_wrap">
            <div
              className="bg_wrap1"
              id="#hero_bg"
              loading="lazy"
              style={{
                backgroundImage: bgbanner
                  ? `url(${bgbanner})`
                  : `url(${obj.image})`,
              }}
            ></div>
          </div>
          <div className="row1 row2">
            <div>
              <div className="column1 column2 column3 css_mix_blend_mode_passthrough last-child">
                <div className="module heading_text heading_text_0  heading_text_align bg_layout_dark">
                  <div
                    // data-aos="fade-down"
                    data-aos="zoom-in"
                    data-aos-duration="700"
                    className="inner_text"
                  >
                    {obj && (
                      <>
                        {obj.details ? (
                          <HTMLContent className="main-head" content={head} />
                        ) : (
                          <h3>{obj.heading1}</h3>
                        )}
                      </>
                    )}
                    {!obj.details && <h1>{obj.heading2}</h1>}
                  </div>
                </div>{" "}
                <div className="module heading_text sub_text_1  heading_text_align bg_layout_dark">
                  <div
                    data-aos="fade-up"
                    data-aos-duration="700"
                    className="inner_text"
                  >
                    <HTMLContent
                      className="main-subhead"
                      content={desc ? desc : obj.heading3}
                    />
                    {/* <p>{desc ? desc : obj.heading3}</p> */}
                  </div>
                </div>
                {obj.details ? (
                  <div
                    data-aos="fade-up"
                    data-aos-duration="700"
                    className="sustainathon_button_module_wrapper"
                  >
                    {status === "ongoing" ? (
                      <a
                        href="#"
                        role="button"
                        onClick={(e) => handleParticipate(e)}
                        className="main_button head_button_margin sustainathon_anim_button sustainathon_button_padding"
                      >
                        <span>{TEXT[language]["HEADER"]["0"]}</span>
                      </a>
                    ) : null}
                    {challengeCheck ? (
                      <a
                        href="#"
                        role="button"
                        value="gotoChallenges"
                        onClick={(e) => scrollTo(e, "gotoChallenges")}
                        className="main_button sustainathon_anim_button sustainathon_button_padding head_button_margin"
                      >
                        <span>{TEXT[language]["HEADER"]["1"]}</span>
                      </a>
                    ) : (
                      ""
                    )}
                    {webinarCheck ? (
                      <a
                        role="button"
                        value="gotoWebinars"
                        onClick={(e) => scrollTo(e, "gotoWebinars")}
                        className="main_button sustainathon_anim_button sustainathon_button_padding head_button_margin"
                      >
                        <span>{TEXT[language]["HEADER"]["2"]}</span>
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {obj && obj.bottom ? (
            <div
              className={
                obj.launch
                  ? "hero_bottam"
                  : obj.events
                  ? "hero_bottam_events"
                  : obj.details
                  ? "hero_bottam_event_details"
                  : "hero_bottam"
              }
            ></div>
          ) : null}
        </div>
        {obj.launch &&
        (events.data.ongoing.length > 0 || events.data.upcoming.length > 0) ? (
          <LaunchEvent
            type={
              events.data && events.data.upcoming.length > 0
                ? TEXT[language]["HEADER"]["3"]
                : events.data.ongoing
                ? TEXT[language]["HEADER"]["4"]
                : ""
            }
            Events={
              events.data && events.data.upcoming.length > 0
                ? events.data.upcoming
                : events.data.ongoing
                ? events.data.ongoing
                : []
            }
          />
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
}

export default Header;

const LaunchEvent = ({ type, Events }) => {
  const { language } = useContext(LanguageContext);
  return (
    <Fragment>
      <Carousel
        className=" carousel_row1 carousel_row2"
        interval={5000}
        controls={true}
        indicators={true}
        keyboard={true}
      >
        {Events &&
          Events.map((event) => (
            <Carousel.Item key={event.id}>
              <div
                onClick={() => {
                  window.location.href = `/events/${event.status}/${event.id}`;
                }}
                style={{
                  backgroundImage: event.bgBanner
                    ? `url(${event.bgBanner})`
                    : "var(--hero-bg-color)",
                  cursor: "pointer",
                }}
                alt="upcomingevt"
                className="banner_content banner_bg"
              >
                <h2>
                  {type && type === "ongoing"
                    ? TEXT[language]["HEADER"]["5"]
                    : TEXT[language]["HEADER"]["6"]}
                </h2>
                <H1Content className="banner_title" content={event.title} />
                <h3>
                  {type && type === "ongoing"
                    ? `${TEXT[language]["HEADER"]["7"]} ${event.startFDate}`
                    : TEXT[language]["HEADER"]["8"]}
                </h3>
                {type === "upcoming" ? (
                  <Countdown launchDate={event.startFDate} />
                ) : (
                  ""
                )}
              </div>
            </Carousel.Item>
          ))}
      </Carousel>
    </Fragment>
  );
};
